/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Modal, Radio, Button, Typography } from "antd";
import { useState } from "react";
// quelld-frontend\src\Pages\DeleteConfirmationModal.jsx
import DeleteConfirmationModal from "../../../Pages/DeleteConfirmationModal.jsx";
const { Title } = Typography;

const modalStyle = css`
  .ant-modal-content {
    border-radius: 12px;
    padding: 24px;
  }

  .ant-radio-wrapper {
    display: block;
    margin-bottom: 12px;
  }

  .ant-btn-primary {
    background-color: #1677ff;
  }
`;

const RecurringEventModal = ({
  visible,
  action = "update",
  occurrenceDate = "2025-06-17",
  onClose,
  onConfirm,
}) => {
  const [value, setValue] = useState("current");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [deletePayload, setDeletePayload] = useState(null);

  // const handleOk = () => {
  //   const payload = {
  //     action,
  //     update_type: value,
  //   };

  //   if (value !== "all") {
  //     payload.occurrence_date = occurrenceDate;
  //   }

  //   setDeletePayload(payload);
  //   setIsModalVisible(true);
  // };


  const handleOk = () => {
    const payload = {
      action,
      update_type: value,
    };
  
    if (value !== "all") {
      payload.occurrence_date = occurrenceDate;
    }
  
    if (action === "delete") {
      setDeletePayload(payload);
      setIsModalVisible(true);
    } else {
      onConfirm(payload);
      onClose();
    }
  };

  const handleConfirmDelete = () => {
    onConfirm(deletePayload);
    setIsModalVisible(false);
    onClose();
  };

  const handleCancelDelete = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={null}
        centered
        css={modalStyle}
      >
        <Title level={4}>
          {action === "delete"
            ? "Delete recurring event"
            : "Edit recurring event"}
        </Title>

        <Radio.Group
          onChange={(e) => setValue(e.target.value)}
          value={value}
          style={{ marginTop: 16 }}
        >
          <Radio value="current">This event</Radio>
          <Radio value="current_and_upcoming">This and upcoming events</Radio>
          <Radio value="all">All events</Radio>
        </Radio.Group>

        <div style={{ textAlign: "right", marginTop: 24 }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button onClick={handleOk}>OK</Button>
        </div>
      </Modal>
      {isModalVisible && !(action == "update") && (
        <DeleteConfirmationModal
          visible={isModalVisible}
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
    </>
  );
};

export default RecurringEventModal;



